import AppConfigurationService from '../app-configuration-service/app-configuration-service';
import HttpService from '../http-service/http-service';
import { DSL_API_PATH, DSL_BASE_URL } from '../../constants';

import {
    VehicleDataSpecRequest,
    VehicleDataTrimsAndSpecApiResponse,
    VehicleDataVinApiResponse,
    VehicleDataYmmRequest,
    VehicleDataYmmApiResponse,
} from './vehicle-data-service.types';

export default class VehicleDataService {
    appConfig = new AppConfigurationService();
    // Avoids submitting duplicate requests on re-renders
    private static ongoingRequests: Map<
        string,
        Promise<VehicleDataVinApiResponse | null>
    > = new Map();

    async getVinVehicleData(
        market: string,
        vin: string
    ): Promise<VehicleDataVinApiResponse | null> {
        const vinOrchestrationUrl =
            DSL_BASE_URL + DSL_API_PATH.VEHICLE_DATA_VIN + `?market=${market}`;

        const requestKey = `${vin}-${market}`;
        if (VehicleDataService.ongoingRequests.has(requestKey)) {
            return VehicleDataService.ongoingRequests.get(
                requestKey
            ) as Promise<VehicleDataVinApiResponse>;
        }

        const requestPromise = HttpService.get<VehicleDataVinApiResponse>(
            encodeURI(vinOrchestrationUrl),
            true,
            {
                headers: {
                    vin,
                },
            }
        )
            .then(({ data }) => {
                if (data.features && data.vehicleDetails) {
                    return data;
                } else return null;
            })
            .catch(e => {
                console.error('getVINVehicleData - ', e);
                return null;
            })
            .finally(() => {
                VehicleDataService.ongoingRequests.delete(requestKey);
            });

        VehicleDataService.ongoingRequests.set(requestKey, requestPromise);
        return requestPromise;
    }

    async getVehicleDataYmm(
        request: VehicleDataYmmRequest
    ): Promise<VehicleDataYmmApiResponse | null> {
        const requestParams = new URLSearchParams();
        (Object.keys(request) as Array<keyof typeof request>).forEach(r =>
            requestParams.append(r, `${request[r]}`)
        );
        return await HttpService.get<VehicleDataYmmApiResponse>(
            `${DSL_BASE_URL}${DSL_API_PATH.VEHICLE_DATA_YMM}?` +
                requestParams.toString(),
            false,
            {},
            10000
        )
            .then(res => {
                return res.data;
            })
            .catch(() => {
                console.error('Cannot retrieve vehicle data');
                return null;
            });
    }

    async getVehicleTrimsAndSpecs(
        request: VehicleDataSpecRequest
    ): Promise<VehicleDataTrimsAndSpecApiResponse | null> {
        const requestParams = new URLSearchParams();
        (Object.keys(request) as Array<keyof typeof request>).forEach(r =>
            requestParams.append(r, `${request[r]}`)
        );

        return await HttpService.get<VehicleDataTrimsAndSpecApiResponse>(
            `${DSL_BASE_URL}${DSL_API_PATH.VEHICLE_DATA_TRIMS_AND_SPECS}?` +
                requestParams.toString(),

            false
        )
            .then(res => {
                if (res.data.trims) return res.data;
                else return null;
            })
            .catch(() => {
                return null;
            });
    }
}

export const vehicleDataService = new VehicleDataService();
